module.exports = __webpack_public_path__ + "img/second_card_balance.81446579.png";